import ApiService from './api.service';

// Constant
const baseUrl = 'advanced_setting/';

const AdvancedSettingService = {
	/**
	 * create settings
	 * @param {Object} body
	 * @param {Sting} userId
	 * @returns {Response} response
	 */
	create({ body, userId }) {
		return ApiService.post(baseUrl + userId, body);
	},
	/**
	 * update settings
	 * @param {Object} body
	 * @param {Sting} userId
	 * @returns {Response} response
	 */
	update({ body, userId }) {
		return ApiService.put(baseUrl + userId, body);
	},
	/**
	 * create settings
	 * @param {Object} body
	 * @param {Sting} userId
	 * @returns {Response} response
	 */
	getByUser({ userId }) {
		return ApiService.get(baseUrl + userId);
	},
};

export default AdvancedSettingService;
